import { render, staticRenderFns } from "./DDtableheaderfilter.vue?vue&type=template&id=7073b2de&scoped=true"
import script from "./DDtableheaderfilter.vue?vue&type=script&lang=js"
export * from "./DDtableheaderfilter.vue?vue&type=script&lang=js"
import style0 from "./DDtableheaderfilter.vue?vue&type=style&index=0&id=7073b2de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7073b2de",
  null
  
)

export default component.exports